import { ReactNode } from 'react';

import { format, isToday, parseISO } from 'date-fns';

import { VabsPaymentDirection, VabsPaymentSystem } from '@/shared/api';
import { ArrowUpRight, ExchangeIcon, TopUpIcon } from '@/shared/assets';
import { cn, getValueWithCurrency } from '@/shared/lib';

import { ITransaction } from '../model/types';

const transactionIcons: Record<VabsPaymentDirection, ReactNode> = {
  [VabsPaymentDirection.Incoming]: <TopUpIcon />,
  [VabsPaymentDirection.Outgoing]: <ArrowUpRight />,
  [VabsPaymentDirection.Both]: <ExchangeIcon />,
};

export const formatAmount = (
  amount: number | string,
  currency: string,
  fixed = 2,
  operand?: '+' | '-'
): string => {
  if (!amount?.toString()) return '0';

  return getValueWithCurrency(
    `${operand} ${Math.abs(+amount).toFixed(fixed)}`,
    currency,
  );
};

export const getTransactionAvatar = (
  transaction: ITransaction,
  className?: string,
): { avatar?: string; defaultAvatar?: ReactNode } => {
  const isExchange = transaction.paymentSystem === VabsPaymentSystem.Exchange
  return {
    defaultAvatar: (
      <div
        className={cn(
          'flex h-10 w-10 items-center justify-center rounded-full bg-base-300',
          className,
        )}
      >
        {transactionIcons[isExchange ? VabsPaymentDirection.Both : transaction.type]}
      </div>
    ),
  };
};

export const groupTransactionsByDate = (
  transactions: ITransaction[],
): Record<string, ITransaction[]> => {
  return transactions.reduce<Record<string, ITransaction[]>>(
    (acc, transaction) => {
      const transactionDate = parseISO(transaction.date);
      const formattedDate = isToday(transactionDate)
        ? 'Today'
        : format(transactionDate, 'dd MMM, yyyy');
      (acc[formattedDate] ??= []).push(transaction);
      return acc;
    },
    {},
  );
};
